import { EventBus } from "../EventBus.js";

export default {
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    filters: {
      default: null,
      type: Object,
      required: false,
    },
  },

  mounted() {
    this.loadRows();

    EventBus.$on("form-submit-success", (data) => {
      this.loadRows();
    });
  },

  data() {
    return {
      rows: [],
      totalRows: 0,
      isLoading: false,
      serverParams: {
        columnFilters: {},
        page: 1,
        perPage: 10,
        _method: "get",
      },
    };
  },

  methods: {
    updateParams(newParams) {
      this.serverParams = { ...this.serverParams, ...newParams };
    },

    onPageChange(params) {
      this.updateParams({
        page: params.currentPage,
      });
      this.loadRows();
    },

    onPerPageChange(params) {
      // stop this code running on startup (even though the "perPage" value hasn't changed!)
      if (params.currentPerPage !== this.serverParams.perPage) {
        this.updateParams({
          perPage: params.currentPerPage,
          // reset to page 1 to avoid 0 results
          page: 1,
        });
        this.loadRows();
      }
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
      this.loadRows();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.updateParams({
        page: 1,
      });
      this.loadRows();
    },

    loadRows() {
      // append additional filters
      if (this.filters) {
        this.serverParams.columnFilters = {
          ...this.serverParams.columnFilters,
          ...this.filters,
        };
      }

      this.isLoading = true;
      this.rows = [];

      axios({
        method: "get",
        url: this.endpoint,
        params: this.serverParams,
        _method: "post",
      })
        .then((response) => {
          this.totalRows = response.data.total;
          this.rows = response.data.data;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
